import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import withStyles from "material-ui/styles/withStyles";

import GridContainer from "components/Grid/GridContainer";
import ItemGrid from "components/Grid/ItemGrid";
import Button from "components/CustomButtons/Button";
import CustomInput from "components/CustomInput/CustomInput";

import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";


class ProjectConfigChoices extends React.Component{
    
    render(){
        return (
          <SweetAlert
              title="Add Choices"
              onConfirm={() => this.props.closeChoicesModal()}
              onCancel={() => this.props.closeChoicesModal()}
              showConfirm={false}
            >
              <GridContainer>
                <ItemGrid xs={12}>
                  <ItemGrid>
                    <label>Value:</label>
                     <CustomInput
                      inputProps={{
                        name: "key:choices",
                        value: this.props.choicesValue,
                        onChange: this.props.onTableUpdate.bind(this)
                      }}
                    />
                  </ItemGrid>
                  <ItemGrid>
                    <label>Label:</label>
                     <CustomInput
                      inputProps={{
                        name: "display:choices",
                        value: this.props.choicesLabel,
                        onChange: this.props.onTableUpdate.bind(this)
                      }}
                    />
                  </ItemGrid>
                  <ItemGrid>
                    <Button type="submit" variant="raised" color="primary" onClick={this.props.onChoicesModalSaved.bind(this)}>
                      Save
                    </Button>
                  </ItemGrid>
                </ItemGrid>
              </GridContainer>
          </SweetAlert>
        );
    }
}

export default withStyles(sweetAlertStyle)(ProjectConfigChoices);


// WEBPACK FOOTER //
// ./src/views/projectconfig/components/ProjectConfigChoices.js